export default __webpack_public_path__ + "images/4667392ad563d7f04e118544c1e65c39.svg";